import { Model } from "@tailflow/laravel-orion/lib/model";

export class Collection extends Model<{
    user_id: number,
    title: string,
    slug: string,
    language: string,
    publish: number,
    created_at: string,
    updated_at: string,
}> {

    $resource(): string {
        return "collections";
    }
}
